export { default as AboutPage } from './AboutPage';
export { default as CareersPage } from './CareersPage';
export { default as GreenPage } from './GreenPage';
export { default as CareersSubPage } from './CareersSubPage';
export { default as CareersOpenPositionPage } from './CareersOpenPositionPage';
export { default as GamesPage } from './GamesPage';
export { default as GenericPage } from './GenericPage';
export { default as HomePage } from './HomePage';
export { default as NewsEventsPage } from './NewsEventsPage';
export { default as PressReleasePage } from './PressReleasePage';
export { default as TeamPage } from './TeamPage';



// WEBPACK FOOTER //
// ./src/modules/pages/index.js